module.exports = __webpack_public_path__ + "img/learn.51a6d1d4.svg";